import { useQuery } from '@tanstack/react-query';

import { atsIntegrationsClient } from 'clients/ATSIntegrationsClient/ATSIntegrationsClient';
import { isAxiosError } from 'helpers/clientHelpers';
import { isObject } from 'helpers/helpers';
import { ValidateAtsConnectionResponseError } from 'shared/legacy/exceptions/ValidateAtsConnectionResponseError';
import { QueryKey } from 'types/query';
import { useCurrentUserQuery } from './useCurrentUserQuery';
import { useGetAllAtsConnectionsQuery } from './useGetAllAtsConnectionsQuery';

export const useHasValidAtsConnectionQuery = () => {
  const { data: currentUser } = useCurrentUserQuery();
  const {
    data: { activeATS },
  } = useGetAllAtsConnectionsQuery();

  return useQuery(
    [QueryKey.useHasValidAtsConnectionQuery, activeATS?.id],
    async () => {
      try {
        const { data } = await atsIntegrationsClient.hasValidATSConnected();

        return data.success === true;
      } catch (e) {
        if (isAxiosError(e)) {
          const response = e.response?.data;

          if (isObject(response)) {
            throw new ValidateAtsConnectionResponseError(
              typeof response.reason === 'string' ? response.reason : undefined,
              typeof response.error_code === 'string' ? response.error_code : 'ats_connection_invalid',
            );
          }
        }

        throw new ValidateAtsConnectionResponseError('Failed to reach ATS connection', 'ats_connection_invalid');
      }
    },
    { enabled: !!currentUser && !!activeATS, retry: false, initialData: false, initialDataUpdatedAt: 0 },
  );
};
